import React, { useEffect } from 'react';//{useState}
import './App.scss';
import { Header } from './components/Header'
import { BrowserRouter as Router, Route } from "react-router-dom";
import Home from './components/Home';
import CompanyDetails from './containers/CompanyDetails';
import CompanyDetailsA from './containers/CompanyDetailsA';
import AccountOpening from './containers/AccountOpening';
import TxnActivities from './containers/TxnActivities';
import ApplicantDetails from './containers/ApplicantDetails';
import BizBankingService from './containers/BizBankingService';
import Disclaimer from './containers/Disclaimer';
import MyInfoLanding from './containers/MyInfoLanding';
import DelegationDetails from './containers/DelegationDetails';
import TaxDetails from './containers/TaxDetails.jsx';
import Cards from './Card/Cards';
import Submit from './containers/Submit';
import DeclarationDetails from './containers/DeclarationDetails';
import UploadDetails from './containers/UploadDetails';
import Preview from './containers/Preview';
import NSApplicantDetails from './nscontainers/NSApplicantDetails';
import MyInfoError from './components/MyInfoError';
import Consent from './nscontainers/Consent';
import NSBizBankingService from './nscontainers/NSBizBankingService';
import NSDelegationDetails from './nscontainers/NSDelegationDetails';
import NSDelegationDetails2 from './nscontainers/NSDelegationDetails2';
import NSTaxDetails from './nscontainers/NSTaxDetails';
import NSUploadDetails from './nscontainers/NSUploadDetails';
import NSSubmit from './nscontainers/NSSubmit';
import InvalidDirectors from './nscontainers/InvalidDirectors';
import InvalidEntity from './nscontainers/InvalidEntity';
import LLPUploadDetails from './nscontainers/LLPUploadDetails';
import ACSUploadDetails from './nscontainers/ACSUploadDetails';
import InvalidApplication from './nscontainers/InvalidApplication';
import SubmitSaveAndContinue from './nscontainers/SubmitSaveAndContinue';
import NonAuthPersonDetails from './nscontainers/NonAuthPersonDetails';
import InvalidOTP from './nscontainers/InvalidOTP';
import storage from './factory/StorageFactory';
import SessionExpired from './components/SessionExpired'; 
import ShareholdersDetails from './nscontainers/ShareholdersDetails.jsx';
import AcctOpeningMY from './containers/AcctOpeningMalaysia';
 

function App() {
  useEffect(() => {
    console.log('@App useEffect')
    const token = storage.getTokenExpiry();
    if(!token){
      return;
    }

    /*
    let localExpTime = new Date(token).getTime();
    let currentTime = new Date();
    currentTime = currentTime.getTime();
    if(currentTime >= localExpTime) {
      window.location.href = "../rsme/SessionExpired";
    }
    */
    
  }, []);
 
  return (
    <Router>
        <div className="content">
          <Header projectName={'rsme'} />
          <Route exact path="/rsme" component={Home} />
          <Route path = "/rsme/CompanyDetails" component={CompanyDetails}  />
          <Route path = "/rsme/CompanyDetailsA" component={CompanyDetailsA}  />
          <Route path = "/rsme/AccountOpening" component={AccountOpening} />
          <Route path = "/rsme/TxnActivities" component={TxnActivities} />
          <Route path = "/rsme/ApplicantDetails" component={ApplicantDetails} />
          <Route path = "/rsme/BizBankingService" component={BizBankingService} />
          <Route path = "/rsme/DelegationDetails" component={DelegationDetails} />
          <Route path = "/rsme/Disclaimer" component={Disclaimer} />
          <Route path = "/rsme/MyInfoLanding" component={MyInfoLanding} />
          <Route path = "/rsme/TaxDetails" component={TaxDetails} />
          <Route path = "/rsme/UploadDetails" component={UploadDetails} />
          <Route path = "/rsme/DeclarationDetails" component={DeclarationDetails} />
          <Route path = "/rsme/Preview" component={Preview} />
          <Route path = "/rsme/Cards" component={Cards} />
          <Route path = "/rsme/Submit" component={Submit} />
          <Route path = "/rsme/NSSubmit" component={NSSubmit} />
          <Route path = "/rsme/MyInfoError" component={MyInfoError} />
          <Route path = "/rsme/NSApplicantDetails" component={NSApplicantDetails} />
          <Route path = "/rsme/NSBizBankingService" component={NSBizBankingService} />
          <Route path = "/rsme/NSDelegationDetails" component={NSDelegationDetails} />
          <Route path = "/rsme/NSDelegationDetails2" component={NSDelegationDetails2} />
          <Route path = "/rsme/NSTaxDetails" component={NSTaxDetails} />
          <Route path = "/rsme/NSUploadDetails" component={NSUploadDetails} />
          <Route path = "/rsme/LLPUploadDetails" component={LLPUploadDetails} />
          <Route path = "/rsme/ACSUploadDetails" component={ACSUploadDetails} />
          <Route path = "/rsme/Consent" component={Consent} />
          <Route path = "/rsme/InvalidDirectors" component={InvalidDirectors} />
          <Route path = "/rsme/InvalidEntity" component={InvalidEntity} />
          <Route path = "/rsme/InvalidApplication" component={InvalidApplication} />
          <Route path = "/rsme/InvalidOTP" component={InvalidOTP} />
          <Route path = "/rsme/SubmitSaveAndContinue" component={SubmitSaveAndContinue} />
          <Route path = "/rsme/NonAuthPersonDetails" component={NonAuthPersonDetails} />
          <Route path = "/rsme/SessionExpired" component={SessionExpired} />
          <Route path = "/rsme/ShareholdersDetails" component={ShareholdersDetails} />
          <Route path = "/rsme/AcctOpeningMY" component={AcctOpeningMY} />
        </div>
        <br></br>
    </Router>
  );
}
export default App;
